import { Box, Button, Typography } from '@mui/material';
import React from 'react';
import AssemblyIndoorImage from 'src/assets/images/AssemblyIndoor.svg?react';
import AssemblyMacCafeImage from 'src/assets/images/AssemblyMacCafe.svg?react';
import ChannelOutdoorImage from 'src/assets/images/ChannelOutdoor.svg?react';
import { CustomButton } from 'src/components/button/Button';
import { Progress } from 'src/components/progress/Progress';
import { ViewOnlyAlert } from 'src/components/viewOnlyAlert';
import { useGetAllLayoutType } from 'src/hooks/api/layoutTypes/useGetAllLayoutTypes';
import { ILayoutType } from 'src/interfaces';
import { lang, useUserRole } from 'src/utils';

import { SelectlayoutTypeProps } from './SelectLayoutType.interface';
import {
  ButtonContainer,
  ButtonWrapper,
  ChannelWrapper,
  IconContainer,
  ImageButton,
  MacCafeIconContainer,
  OutdoorIconContainer,
  Step,
  Wrapper,
} from './SelectLayoutType.styled';

export const SelectLayoutType = (props: SelectlayoutTypeProps) => {
  const { data: layoutTypes = [], isLoading, error } = useGetAllLayoutType();
  const [selectedOptions, setSelectedOptions] = React.useState({
    layout_type_id: 0,
    layout_type_name: '',
  });

  const handleSelect = (id: number, name: string) => {
    setSelectedOptions({
      layout_type_id: id,
      layout_type_name: name,
    });
  };
  const handleNext = () => {
    props.setLayoutTypeId(selectedOptions.layout_type_id);
    props.setActive('');
  };
  const handleCancel = () => {
    props.onClose();
  };
  const isDisabled = () => {
    if (selectedOptions.layout_type_id) return true;
    else return false;
  };
  const { isViewOnly } = useUserRole();

  return (
    <Wrapper>
      <Box sx={{ position: 'absolute', top: 0, right: 0, margin: 3 }}>
        {isViewOnly && <ViewOnlyAlert />}
      </Box>
      {isLoading ? (
        <Progress />
      ) : error ? (
        <h3>{lang.error}</h3>
      ) : (
        <Step sx={{ maxWidth: 'lg' }}>
          <Typography variant="h1" textAlign="center">
            Let's create an assembly
          </Typography>
          <ChannelWrapper>
            {layoutTypes?.map((layoutType: ILayoutType, index: number) => (
              <ImageButton
                key={index}
                selected={selectedOptions.layout_type_id === layoutType.id}
                onClick={() => handleSelect(layoutType.id, layoutType.name)}>
                {layoutType.name === 'Outdoor' ? (
                  <OutdoorIconContainer>
                    <ChannelOutdoorImage />
                  </OutdoorIconContainer>
                ) : layoutType.name === 'Indoor' ? (
                  <IconContainer>
                    <AssemblyIndoorImage />
                  </IconContainer>
                ) : (
                  <MacCafeIconContainer>
                    <AssemblyMacCafeImage />
                  </MacCafeIconContainer>
                )}
                {layoutType.name}
              </ImageButton>
            ))}
          </ChannelWrapper>
          {!isViewOnly && (
            <ButtonContainer>
              <ButtonWrapper>
                <CustomButton variant="text" onClick={handleCancel}>
                  Cancel
                </CustomButton>
                <Button
                  variant="contained"
                  onClick={handleNext}
                  disabled={!isDisabled()}>
                  Next
                </Button>
              </ButtonWrapper>
            </ButtonContainer>
          )}
        </Step>
      )}
    </Wrapper>
  );
};
